import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Dialog } from '../../../base/dialog';
import Icon from '../../../base/icons/components/Icon';
import { IconRaisedHand } from '../../../base/icons/svg';
const useStyles = makeStyles()(theme => {
    return {
        content: {
            textAlign: 'center'
        },
        raiseHand: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
            margin: `${theme.spacing(3)} 0`
        },
        raiseHandTooltip: {
            border: '1px solid #444',
            borderRadius: '6px',
            fontSize: '13px',
            padding: '6px 12px'
        },
        raiseHandIcon: {
            alignItems: 'center',
            backgroundColor: '#4b6790',
            borderRadius: '50%',
            display: 'flex',
            height: '48px',
            justifyContent: 'center',
            width: '48px'
        }
    };
});
/**
 * Dialog shown to a visitor when they join, explaining they are a view-only viewer and how to ask to
 * join the conversation (raise hand). Mirrors upstream Jitsi's JoinMeetingDialog.
 *
 * @returns {JSX.Element}
 */
const JoinMeetingDialog = () => {
    const { t } = useTranslation();
    const { classes } = useStyles();
    return (React.createElement(Dialog, { hideCancelButton: true, okKey: 'dialog.Ok', onSubmit: () => true, titleKey: 'visitors.joinMeeting.title', width: 'small' },
        React.createElement("div", { className: classes.content },
            React.createElement("p", null, t('visitors.joinMeeting.description')),
            React.createElement("div", { className: classes.raiseHand },
                React.createElement("p", { className: classes.raiseHandTooltip }, t('visitors.joinMeeting.raiseHand')),
                React.createElement("div", { className: classes.raiseHandIcon },
                    React.createElement(Icon, { color: '#ffffff', size: 24, src: IconRaisedHand }))),
            React.createElement("p", null, t('visitors.joinMeeting.wishToSpeak')))));
};
export default JoinMeetingDialog;
